import { connect } from 'react-redux';

import Styles from './styles.module.scss';
import Tooltip from '../../Tooltip';
import withComponentName from '../../../decorators/withComponentName';

export const WatchlistRightBarHeader = (props) => {
  const {
    maxWatchlistSize,
    activeWatchlistTopics,
  } = props;

  return (
    <div className={`${Styles.watchlist_rightbar_header} d-flex justify-content-between align-md-items-center`}>
      <h3>
        Topics on your watchlist
        <span className={Styles.counter}>{`${activeWatchlistTopics.length} / ${maxWatchlistSize}`}</span>
      </h3>
      <Tooltip
        id="WatchlistTooltip"
        className={Styles.tooltip}
      >
        <div className={Styles.watchlist_tooltip_inner}>
          <span>
            Add or remove topics on your watchlist
            {' '}
            <a href="/features/watchlists" target="_blank" rel="noopener noreferrer">
              <span>Learn more</span>
            </a>
          </span>
        </div>
      </Tooltip>
    </div>
  );
};

function mapToStateProps({ subscriptions, watchlistReducer }) {
  const { permissions } = subscriptions;
  const { activeWatchlistTopics } = watchlistReducer;
  const {
    max_watchlist_size: maxWatchlistSize,
    access_levels: accessLevels,
  } = permissions;

  return {
    maxWatchlistSize,
    accessLevels,
    activeWatchlistTopics,
  };
}

export default withComponentName(connect(mapToStateProps)(WatchlistRightBarHeader));
